import $ from 'jquery';
import 'vendor/jquery/textcomplete';

const ExpressionAutoComplete = function(features) {
  var numberDemographicNodes = (features.enhancedCallerProfiles) ? ['age'] : [],
    infutorEnabled = features.enhancedCallerProfiles == 'Infutor',
    numberEnhancedProfilesDemographicNodes = (features.enhancedCallerProfiles && infutorEnabled)
      ? ['length_of_residence', 'home_market_value', 'household_income'] : [],
    NUMBER_NODES = ['duration', 'connect_duration'].concat(numberDemographicNodes).concat(numberEnhancedProfilesDemographicNodes),

    advertiserNode =  (features.customDataAccessLevel === "Brand") ? ['advertiser_name'] : [],
    affiliateNode = features.showAffiliates ? ['affiliate_name'] : [],
    STRING_COMPARE_NODES = [
      'media_type',
      'promo_number_description',
      'advertiser_campaign_name',
      'end_of_call_reason'
    ].concat(advertiserNode, affiliateNode),

    stringDemographicNodes = features.enhancedCallerProfiles ? ['gender', 'address_type'] : [],
    stringEnhancedProfilesDemographicNodes = (features.enhancedCallerProfiles && infutorEnabled)
      ? ['occupation', 'home_owner_status', 'education', 'marital_status'] : [],
    STRING_LIST_NODES = ['signal', 'previous_signal']
      .concat(stringDemographicNodes).concat(stringEnhancedProfilesDemographicNodes),

    voiceSignalNodes = features.voice ? ['voice_signal'] : [],
    generalEnhancedProfileDemographicNodes = (features.enhancedCallerProfiles && infutorEnabled)
      ? ['has_children', 'high_net_worth'] : [],
    NODES = [
      'during_hours',
      'mobile',
      'landline',
      'repeat',
      'pool_param',
      'sms_sent'
    ].concat(NUMBER_NODES).concat(STRING_COMPARE_NODES).concat(STRING_LIST_NODES).concat(generalEnhancedProfileDemographicNodes).concat(voiceSignalNodes),

    NUMBER_OPERATORS = ['>', '<', '>=', '<=', '=', '!='],
    STRING_COMPARE_OPERATORS = ['=', '!=', 'contains', 'present'],
    STRING_LIST_OPERATORS = ['=', '!='],

    Regex = {
      WHITESPACE: "\\s+",
      NON_WHITESPACE_CHARACTERS: "\\S*?",
      EXISTING_WORDS: ".*",
      WORD_BOUNDARY: "\\b"
    };

  // polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
  if (!String.prototype.includes) {
    String.prototype.includes = function() {
      'use strict';
      return String.prototype.indexOf.apply(this, arguments) !== -1;
    };
  }

  return {

    init: function(el) {
      $(el).textcomplete([
        {
          words: NUMBER_OPERATORS,
          match: new RegExp(
            "(" + Regex.EXISTING_WORDS + ")" +
            Regex.WORD_BOUNDARY + "(" + NUMBER_NODES.join('|') + ")" +
            Regex.WHITESPACE + "(" + Regex.NON_WHITESPACE_CHARACTERS + ")$"
          ),
          search: function(term, callback) {
            callback($.map(this.words, function(word) {
              // if no chars, return all
              if (term && term.length === 0) {
                return word;
              }

              // otherwise search everywhere
              return (word.includes(term)) ? word : null;
            }));
          },
          index: 3,
          replace: function(word) {
            return '$1$2 ' + word + ' ';
          }
        },

        {
          words: STRING_COMPARE_OPERATORS,
          match: new RegExp(
            "(" + Regex.EXISTING_WORDS + ")" +
            Regex.WORD_BOUNDARY + "(" + STRING_COMPARE_NODES.join('|') + ")" +
            Regex.WHITESPACE + "(" + Regex.NON_WHITESPACE_CHARACTERS + ")$"
          ),
          search: function(term, callback) {
            callback($.map(this.words, function(word) {
              // if no chars, return all
              if (term && term.length === 0) {
                return word;
              }

              // if only one char, just look at the front
              if (term.length === 1) {
                return word.indexOf(term) === 0 ? word : null;
              }

              // otherwise search everywhere
              return (word.includes(term)) ? word : null;
            }));
          },
          index: 3,
          replace: function(word) {
            var replacedString = '$1$2 ' + word + ' ';

            if (word == 'present') {
              return replacedString;
            } else {
              return [replacedString + '"', '"'];
            }
          }
        },

        {
          words: STRING_LIST_OPERATORS,
          match: new RegExp(
            "(" + Regex.EXISTING_WORDS + ")" +
            Regex.WORD_BOUNDARY + "(" + STRING_LIST_NODES.join('|') + ")" +
            Regex.WHITESPACE + "(" + Regex.NON_WHITESPACE_CHARACTERS + ")$"
          ),
          search: function(term, callback) {
            callback($.map(this.words, function(word) {
              // if no chars, return all
              if (term && term.length === 0) {
                return word;
              }

              // if only one char, just look at the front
              if (term.length === 1) {
                return word.indexOf(term) === 0 ? word : null;
              }

              // otherwise search everywhere
              return (word.includes(term)) ? word : null;
            }));
          },
          index: 3,
          replace: function(word) {
            var replacedString = '$1$2 ' + word + ' ';

            if (word == 'present') {
              return replacedString;
            } else {
              return [replacedString + '"', '"'];
            }
          }
        },

        {
          words: NODES,
          match: /\b(\w{1,})$/,
          search: function(term, callback) {
            callback($.map(this.words.sort(), function(word) {
              // if only one char, just look at the front
              if (term.length === 1) {
                return word.indexOf(term) === 0 ? word : null;
              }

              // otherwise search everywhere
              return (word.includes(term)) ? word : null;
            }));
          },
          index: 1,
          replace: function(word) {
            return word;
          }
        }
      ]);
    }
  };
};

export default ExpressionAutoComplete;
